import { CategoryChartComparisonData, CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";

// import { queryEntities } from "../misc";
import { getKpisForProvidersWithCategoryChart } from "../opendata";
import { getPerConnectionResults } from "./getPerConnectionResults";

export const fetchFigureSolidDashPerConnectionKpiComparisonChartData: CategoryChartQueryFn = async ({
    metadata,
    categoryChart,
    providers,
    kpis,
    category
}: CategoryChartQueryParam): Promise<CategoryChartComparisonData> => {
    const provider = providers?.[0];
    if (!metadata || !provider || !categoryChart || kpis == null || !kpis?.length) return null;

    const kpiReportResults = await getKpisForProvidersWithCategoryChart(kpis, providers, true, categoryChart);
    if (!kpiReportResults) return null;

    const { unit, year, figures, graph, waterProviders } = getPerConnectionResults(
        kpis,
        metadata,
        kpiReportResults,
        providers,
        providers?.map(d => `${d.name}`) ?? [],
        kpis[0][2] ?? "",
        category,
        categoryChart
    );

    return {
        title: categoryChart.displayTitle,
        waterProviders,
        unit,
        year,
        figures,
        graph
        // graph: graph
        //     ? {
        //           ...graph,
        //           linesDataSeriesName: providers.map(
        //               d => `${d.name} ${unit == null ? "" : `(${isUnitDollar(unit) ? "$" : unit})`}`
        //           )
        //       }
        //     : null
    };
};
